import {
  updateAppManifestComponents,
  updateMonitoring,
  updateTopology,
} from '@wix/cli-app-manifest';
import type { Monitoring } from '@wix/cli-app-manifest';
import type { ARMClient } from '@wix/arm-client';
import type { ProjectModel } from '../model.js';
import { readAppManifestFile } from '../app-manifest/file.js';
import type { BlocksComponentsData } from '../blocks/blocks-services-client.js';

export const createPreviewTag = async ({
  model,
  arm,
  serveUrl,
  backendServerUrl,
  blocksComponentsData,
  topologyComponentId,
  monitoringData,
  monitoringComponentId,
}: {
  model: ProjectModel;
  arm: ARMClient;
  serveUrl: string;
  backendServerUrl?: string;
  blocksComponentsData?: BlocksComponentsData;
  topologyComponentId?: string;
  monitoringData?: Monitoring['compData']['monitoring'];
  monitoringComponentId?: string;
}) => {
  const manifest = await readAppManifestFile(model.projectFolder);

  const updatedManifest = updateMonitoring(
    updateTopology(
      updateAppManifestComponents({
        manifest,
        blocksComponentsData,
        backendServerUrl,
        baseUrl: serveUrl,
      }),
      {
        id: topologyComponentId,
        baseApiUrl: backendServerUrl,
      }
    ),
    {
      id: monitoringComponentId,
      monitoring: monitoringData,
    }
  );

  return arm.createAppRelease(updatedManifest, model.config.projectId);
};
